import types from './types';

import statementService from 'src/services/MonthlyStatement';
import statementModel from 'src/model/monthlyStatement.model';

const getMonthlyStatement = (page: number, period: number, size: number) => {
  return (dispatch: any) => {
    dispatch(getMonthlyStatementIsPending(true));
    statementService
      .getMonthlyStatements(page, period, size)
      .then((response: any) => {
        dispatch(clearStatements());
        if (response) {
          dispatch(setMonthlyStatementContent(response));
          dispatch(getMonthlyStatementIsPending(false));
        }
      })
      .catch(error => {
        console.log(error);
        dispatch(setError('getMonthlyStatement', error));
        dispatch(getMonthlyStatementIsPending(false));
      });
  };
};

const getMonthlyStatementIsPending = (isPending: boolean) => {
  return { type: types.GET_MONTHLY_STATEMENT_IS_PENDING, payload: isPending };
};

const setMonthlyStatementContent = (content: statementModel) => {
  return { type: types.SET_CONTENT, payload: content };
};

const clearStatements = () => {
  return { type: types.CLEAR_ALL };
};

const setError = (action: string, error: any) => {
  return {
    type: types.MONTHLY_STATEMENT_ERROR,
    payload: { caller: action, error }
  };
};

export default {
  getMonthlyStatement
};
